import 'css-chunksrc/client/pages/projectPage/exportsPage/resourceReport/styles.scss';export default {
  "resourceReport": "_resourceReport_1fvex_1",
  "checked": "_checked_1fvex_10",
  "checkbox": "_checkbox_1fvex_14",
  "col": "_col_1fvex_20",
  "name": "_name_1fvex_24",
  "description": "_description_1fvex_31",
  "button": "_button_1fvex_36"
};